/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'submit-info': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M583.68 73.216A102.093 102.093 0 01512 102.4H157.389c-61.133 0-54.989-5.632-54.989 46.285V866.61c0 56.525-1.536 54.989 54.989 54.989h713.318c54.477 0 50.893 3.686 50.893-54.989v-343.04c0-28.672 11.776-54.681 30.72-73.216l71.68 73.216v343.04C1024 979.763 983.757 1024 870.707 1024H157.39C44.339 1024 0 979.763 0 866.611V148.685C0 35.533 44.34 0 157.389 0H512l71.68 73.216z"/><path pid="1" d="M460.8 102.4a51.2 51.2 0 010-102.4H768a51.2 51.2 0 010 102.4H460.8zM1024 563.2a51.2 51.2 0 01-102.4 0V460.8a51.2 51.2 0 01102.4 0v102.4zM900.608 166.707a56.32 56.32 0 0182.944 76.186L582.246 679.526a85.3 85.3 0 01-119.808-.204L270.95 488.346a56.32 56.32 0 0179.463-79.77l171.213 170.598 378.982-412.467z"/>'
  }
})
